import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/ceLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-480e615f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6 18 18 6M6 6l12 12"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "w-6 h-6",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M4 6H20M4 12H20M4 18H11",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "fixed inset-y-0 left-0 z-30 overflow-y-auto transition duration-300 transform bg-gray-900 lg:translate-x-0 lg:static lg:inset-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center mt-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo",
      src: _imports_0
    })
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-5 mb-5 text-center" }, "PLATEFORME", -1))
const _hoisted_10 = { class: "menu bg-base-200 rounded-box" }
const _hoisted_11 = {
  class: "collapse list-unstyled",
  id: "homeCatalogue"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "Catégories", -1))
const _hoisted_13 = { class: "collapse list-unstyled" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Filtres", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Arborescence", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mises en avant", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "Produits", -1))
const _hoisted_18 = { class: "collapse list-unstyled" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "API Carte cadeau", -1))
const _hoisted_20 = { class: "collapse list-unstyled" }
const _hoisted_21 = { class: "w-11/12" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "Stock", -1))
const _hoisted_23 = { class: "collapse list-unstyled" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exports", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "Fournisseurs", -1))
const _hoisted_26 = {
  class: "collapse list-unstyled",
  id: "pageSupplier"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fournisseurs", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Transporteurs", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "Login", -1))
const _hoisted_30 = {
  class: "collapse list-unstyled",
  id: "Login"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Carrousels", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "Homepage", -1))
const _hoisted_33 = {
  class: "collapse list-unstyled",
  id: "Homepage"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Carrousels", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nos offres du moment", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nouveautés", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Voyage", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Région", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "Sécurité", -1))
const _hoisted_40 = { class: "collapse list-unstyled" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Whitelist 2FA", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Authentification forte", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Personnes blacklistées", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Utilisateurs Actifs", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Versions mobiles approuvées", -1))
const _hoisted_46 = { class: "collapse list-unstyled" }

import { ref } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

    const sidebarVisible = ref(false);

    const toggleSidebar = () => {
        sidebarVisible.value = !sidebarVisible.value;
    };

    


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      onClick: toggleSidebar,
      class: _normalizeClass(["text-gray-500 focus:outline-none lg:hidden", { 'sidebar-visible': !sidebarVisible.value }])
    }, [
      (sidebarVisible.value)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true),
      (!sidebarVisible.value)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["flex sidebar", { 'sidebar-visible': !sidebarVisible.value }]),
      ref: "sidebar"
    }, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("nav", null, [
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/admin/dashboard" }, {
                default: _withCtx(() => [
                  _createTextVNode("Dashboard ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("details", null, [
                _createElementVNode("summary", null, _toDisplayString(_ctx.$t("mainMenu.catalog.nameSection")), 1),
                _createElementVNode("ul", _hoisted_11, [
                  _createElementVNode("li", null, [
                    _createElementVNode("details", null, [
                      _hoisted_12,
                      _createElementVNode("ul", _hoisted_13, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: { name: 'listCategories' } }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.category")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: { name: 'filterableCategoryList' } }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: { name: 'categoryTreeview' } }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: { name:'listMegaMenusCategories'} }, {
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("details", null, [
                      _hoisted_17,
                      _createElementVNode("ul", _hoisted_18, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/catalogue/ListProducts" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.products")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/properties/list" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.properties")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: { name: 'listVariantProductCollection' } }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.variantProductCollection")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: { name: 'companiesList' } }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.companiesList")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: { name: 'ListUrssaf' } }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.urssaf")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("details", null, [
                      _hoisted_19,
                      _createElementVNode("ul", _hoisted_20, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/catalogue/gift-card-product-api" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.jackpot")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_21, [
                          _createVNode(_component_router_link, { to: "/admin/catalogue/list-ogloba-order" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.orderManualOgloba")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("details", null, [
                      _hoisted_22,
                      _createElementVNode("ul", _hoisted_23, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/catalogue/ListDocuments" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.documents")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, { to: "/admin/catalogue/ListCodes" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.codes")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'soldExport' } }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: "/admin/catalogue/monitoring-ogloba-order" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("mainMenu.catalog.monitoringOglobaOrder")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("details", null, [
                _hoisted_25,
                _createElementVNode("ul", _hoisted_26, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'suppliersList' } }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'transporterList' } }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("details", null, [
                _hoisted_29,
                _createElementVNode("ul", _hoisted_30, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'carouselLoginList' } }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("details", null, [
                _hoisted_32,
                _createElementVNode("ul", _hoisted_33, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'carouselList' } }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'middleMenuList' } }, {
                      default: _withCtx(() => [
                        _hoisted_35
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'newsList' } }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'travelList' } }, {
                      default: _withCtx(() => [
                        _hoisted_37
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'regionList' } }, {
                      default: _withCtx(() => [
                        _hoisted_38
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("details", null, [
                _hoisted_39,
                _createElementVNode("ul", _hoisted_40, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'whitelist' } }, {
                      default: _withCtx(() => [
                        _hoisted_41
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'enable2FaStrongAuthentication' } }, {
                      default: _withCtx(() => [
                        _hoisted_42
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'usersBlackList' } }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'enabledUsersList' } }, {
                      default: _withCtx(() => [
                        _hoisted_44
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'mobileApprovedVersionList' } }, {
                      default: _withCtx(() => [
                        _hoisted_45
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("details", null, [
                _createElementVNode("summary", null, _toDisplayString(_ctx.$t("mainMenu.registrationNumber.nameSection")), 1),
                _createElementVNode("ul", _hoisted_46, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'importCompanyMatricule' } }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("mainMenu.registrationNumber.importRegistrationNumbers")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'companyMatriculeWithUserList' } }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("mainMenu.registrationNumber.companyMatricules")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}
}

})